export const ANEEL_PORTAL_URL = "https://portalrelatorios.aneel.gov.br/luznatarifa/basestarifas";
